import { Map } from 'immutable'

export const INITIAL_STATE = Map({
  calibrations: {},
  calibrationsIsLoading: {},
  addCalibrationLoading: false,
})
